import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FlaskConical, Download, Upload } from "lucide-react";
import { api, downloadFile } from "@/lib/api";
import { Pill, fmtDate, errMsg } from "./shared";
import VerificationResult from "./VerificationResult";

export default function DscTestRunCard({ certOk }) {
  const [run, setRun] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/dsc/test-run").then((r) => setRun(r.data)).catch(() => setRun({ status: "none" }));
  useEffect(() => { load(); }, []);
  const create = async () => {
    try { await api.post("/admin/dsc/test-run"); toast.success("Test document created"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/admin/dsc/test-run/upload", fd);
      data.ok ? toast.success("Real token test PASSED") : toast.error("Test failed — see the checks");
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!run) return null;
  const has = run.status !== "none";
  return (
    <div className="admin-card p-5 mb-6" data-testid="dsc-test-run-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-bold flex items-center gap-2"><FlaskConical size={16} className="text-orange-400"/>Real USB-token test</div>
          <p className="text-xs text-slate-500 mt-1">Before signing real agreements, sign a harmless test document once to confirm the token, Acrobat and Karmivo's verification all work together.</p>
        </div>
        {has && <div className="flex items-center gap-2 text-xs"><Pill value={run.status} testid="dsc-test-status"/><span className="text-slate-500">{fmtDate(run.tested_at || run.created_at)}</span></div>}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        <Button size="sm" className="bg-orange-500 hover:bg-orange-600 h-9" disabled={!certOk} onClick={create} data-testid="dsc-test-create">1. Create test document</Button>
        <Button size="sm" variant="outline" className="border-slate-700 bg-transparent text-slate-200 h-9" disabled={!has} onClick={() => downloadFile("/admin/dsc/test-run/unsigned.pdf", "Karmivo_DSC_Test_TO_SIGN.pdf").catch(() => toast.error("Download failed"))} data-testid="dsc-test-download"><Download size={13} className="mr-1"/>2. Download & sign in Acrobat</Button>
        <label className={`inline-flex items-center rounded-md px-3 h-9 text-sm font-medium cursor-pointer ${has && !busy ? "bg-orange-500 hover:bg-orange-600 text-white" : "bg-slate-800 text-slate-500 pointer-events-none"}`} data-testid="dsc-test-upload-label">
          <Upload size={13} className="mr-1"/>{busy ? "Verifying…" : "3. Upload signed test PDF"}
          <input type="file" accept="application/pdf" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="dsc-test-upload"/>
        </label>
      </div>
      {!certOk && <p className="text-xs text-amber-300 mt-2">Register the Director's certificate first.</p>}
      {run.checks && <div className="mt-4"><VerificationResult test r={{ ok: run.status === "passed", checks: run.checks, signature: run.signature }}/></div>}
    </div>
  );
}
